import React from 'react';

import Main from 'Elements/Main';
import Section from 'Elements/Section';

import Grid, { Col } from 'Components/Grid';
import Breadcrumbs, { BreadcrumbsProps } from 'Components/Breadcrumbs';
import Featured, { FeaturedFiftyTwoWeeksCardProps } from 'Components/Card/FiftyTwoWeeks/Featured';

import FiftyTwoWeeks, { FiftyTwoWeeksHerobannerProps } from 'Modules/HeroBanner/FiftyTwoWeeks';
import Socials, { PromoPointSocialsProps } from 'Modules/PromoPoint/Socials';
import FiftyTwoWeeksListing, { FiftyTwoWeeksListingProps } from 'Modules/Listing/FiftyTwoWeeks';

import { StyledSection } from './Listing.styled';

export interface Props {
    breadcrumbs: BreadcrumbsProps;
    heroBanner: FiftyTwoWeeksHerobannerProps;
    featuredCard: FeaturedFiftyTwoWeeksCardProps;
    listing: FiftyTwoWeeksListingProps;
    promo: PromoPointSocialsProps;
}

const Listing: React.FC<Props> = props => {
    const { breadcrumbs, heroBanner, featuredCard, listing, promo } = props;

    return (
        <Main>
            <Breadcrumbs {...breadcrumbs} />
            <FiftyTwoWeeks {...heroBanner} />
            <StyledSection background id="52-weeks-featured-article">
                <Grid>
                    <Col l={[2, 12]}>
                        <Featured {...featuredCard} />
                    </Col>
                </Grid>
            </StyledSection>
            <FiftyTwoWeeksListing {...listing} />
            <Section background id="52-weeks-promo">
                <Grid>
                    <Col>
                        <Socials {...promo} />
                    </Col>
                </Grid>
            </Section>
        </Main>
    );
};

export default Listing;
